import { ApiService, ApiServiceInterface } from "../../../../../core";
import { SearchController, SearchData } from "../interfaces";

interface SearchResponse {
    success: boolean;
    response: SearchData[];
}

export class SearchControllerImpl implements SearchController {
    private api: ApiServiceInterface;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }
    async getSearch(term: string): Promise<SearchData[]> {
        try {
            const formData = new FormData();
            formData.append("term", term);

            const data: SearchResponse = await this.api.post('/search', formData)
            if (data.success) return data.response;
            throw new Error("Method not implemented.");

        } catch (error) {
            throw new Error("Error: Method not implemented.");
        }
    }
}